import React from "react";
import {getSimulationState, getSimulationStateColor} from "../../utils/utils";
import {SimulationState} from "../../api/entities/replancity_RunnedAlgorithm";
import './simulation-state-badge.scss';
import {useTranslation} from "react-i18next";


const SimulationStateBadge = ({state}) => {
    const {t} = useTranslation();

    return (
        <span
            className="simulation-state"
            style={{'background': getSimulationStateColor(state)}}
        >
            {getSimulationState(state as SimulationState, t)}
        </span>
    )
}

export default SimulationStateBadge;